import React, { useState } from "react";
import home from "../../assets/img/home.png";
import { Link, useNavigate } from "react-router-dom";

function CommunityMap() {
  const [selectedTab, setSelectedTab] = useState("community"); // Default tab
  const navigate = useNavigate();

  // 함수를 통해 선택된 탭을 변경하는 로직
  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    navigate(`/${tab}`);
  };

  // 함수를 통해 선택된 탭에 따라 타이틀을 동적으로 생성
  const renderTitle = () => {
    switch (selectedTab) {
      case "community":
        return <p>공지사항</p>;
      case "community2":
        return <p>활동 소식</p>;
      case "community3":
        return <p>뉴스레터</p>;
      default:
        return null; // Default case, can be customized based on your requirements
    }
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="flex gap-3 text-sm font-semibold">
        {/* 아이콘 */}
        <Link to="/">
          <img src={home} alt="logo" className="h-4" />
        </Link>
        <p>></p>
        <Link to="/works">
          <p>사업 소개</p>
        </Link>
        <p>></p>
        <p className="text-main">{renderTitle()}</p>
      </div>
      {/* 타이틀 */}
      <p className="text-5xl font-bold text-gray-900">{renderTitle()}</p>
      {/* 상세 */}
      <div>
        <div className="inline-flex items-center h-10 gap-1 px-1 bg-gray-100 rounded-full">
          <button
            onClick={() => handleTabChange("community")}
            className={`h-8 px-6  rounded-full ${
              selectedTab === "community"
                ? "bg-main text-white"
                : "text-gray-500"
            }`}
          >
            {" "}
            공지사항
          </button>
          <button
            onClick={() => handleTabChange("community2")}
            className={`h-8 px-6 rounded-full ${
              selectedTab === "community2"
                ? "bg-main text-white"
                : "text-gray-500"
            }`}
          >
            {" "}
            활동 소식
          </button>
          <button
            onClick={() => handleTabChange("community3")}
            className={`h-8 px-6 rounded-full ${
              selectedTab === "community3"
                ? "bg-main text-white"
                : "text-gray-500"
            }`}
          >
            {" "}
            뉴스레터
          </button>
        </div>
      </div>
    </div>
  );
}

export default CommunityMap;
